import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  attempt: null,
  logout: null,
  failure: ['error'],
  success: ['token', 'user']
}, {prefix: "USER_AUTHENTICATION_"});
